var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoopLogo25Color(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "coop-logotype",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 368.2 107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .c {\n        fill: #00a143;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    "data-name": "path10",
    className: "c",
    d: "M316,65.6c-14.3,0-20.1-10.8-20.1-22.8s5.9-23,20.1-23,20.1,10.8,20.1,23c.1,12-5.8,22.8-20.1,22.8M217.4,65.6c-14.3,0-20.1-10.8-20.1-22.8s5.9-23,20.1-23,20.1,10.8,20.1,23-5.8,22.8-20.1,22.8M124.3,65.6c-14.3,0-20.1-10.8-20.1-22.8s5.8-23,20.1-23,20.1,10.8,20.1,23-5.8,22.8-20.1,22.8M316,0c-23.4,0-42.4,9.8-49.3,27.3-6.9-17.5-25.9-27.3-49.3-27.3-20.8,0-38.1,7.7-46.6,21.7C162.4,7.8,145.1,0,124.3,0c-29.6,0-52.2,15.7-52.2,42.7,0,6.8,1.4,12.9,4.1,18.2-.3.1-.7.3-1,.4-1.3.5-2.8,1-4.4,1.5-4.1,1.1-8.7,1.7-13.3,1.7-13.4,0-25.5-8.4-25.5-21.4,0-14.1,10.3-22.5,23.7-22.5,5.1.1,9.1.4,13.1,1.8,0,0,4.6-10.1,12.4-15.9-1.5-.7-3.1-1.4-4.7-2.1-7-3-15.2-4.4-24.4-4.4C22.5,0,0,15.7,0,42.7s22.5,42.6,52.1,42.6c7.8,0,16.5-1.1,24-3.2,2.8-.7,9.4-2.9,14.2-5.7,9,5.8,20.8,8.9,34,8.9,20.8,0,38.1-7.7,46.6-21.7,8.5,13.9,25.8,21.7,46.6,21.7s38-7.7,46.5-21.6v43.3h31.8v-24.5c6.2,1.8,13,2.8,20.3,2.8,29.6,0,52.1-15.6,52.1-42.6S345.6,0,316,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoopLogo25Color);
export default __webpack_public_path__ + "static/media/coop_logo25_color.19fcfad14d9860065ed04877c0290d30.svg";
export { ForwardRef as ReactComponent };